import styled from 'styled-components';

export const SkipToContentWrapper = styled.div`
  position: absolute;
  top: 8px;
  left: 8px;
  z-index: 9999;
`;

export const SkipToContentPill = styled.span`
  display: inline-block;
  padding: 8px 12px;
  border-radius: 6px;
  background-color: ${({ theme }) => theme.colors.AccentPurple};
  color: ${({ theme }) => theme.colors.White};
  font-size: 14px;
  font-weight: 600;
  line-height: 1.4;
  white-space: nowrap;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.18);
`;
